import PurchaseBusinessService from '../../purchase-business-service';
import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import {purchaseProjectStatus} from '@/utils/mixins/purchase-project-status';
import { changeSkin } from '@/utils/common.js';
import Payment from '@/components/payment/payment.vue';
import { successMessage, errorMessage } from '@/utils/message.js';
import QrCodePage from '@/components/qr-code/index.vue';
import extendAnnouncementMixins from '@/utils/mixins/extend-announcement.js';

export default {
  components: {
    Pagination,
    Payment,
    QrCodePage
  },
  mixins: [purchaseProjectStatus, extendAnnouncementMixins],
  data() {
    return {
      currentProjectId: '',
      showPayment: false,
      projectStatusArr: [],
      projectTypeArr: [],
      total: 0,
      currentPage: 1,
      pageSize: 5,
      tableList: [],
      qrCodeVisible: false,
      projectId: ''
    };
  },
  created() {
    const arr = [
      ['projectStatusArr', 'PURCHASE_STATUS'], ['projectTypeArr', 'PURCHASE_PROJECT_TYPE']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = res.data;
        }
      });
    });
    this.getPurchaseProjectList();
  },
  computed: {
  },
  filters: {
    toFixed: function (value) {
      if (!value) return '';
      return ((value)/10000).toFixed(2);
    }
  },
  methods: {
    changeSkin,
    // 收不到签约短信
    qrCodeClick(projectId) {
      this.projectId = projectId;
      this.qrCodeVisible = true;
    },
    // 获取发布项目列表
    getPurchaseProjectList(page){
      if (page) {
        this.currentPage = page.pageNo;
        this.pageSize = page.pageSize;
      }
      PurchaseBusinessService.getPurchaseProjectList(this.currentPage, this.pageSize).then(res => {
        if (res && res.code === '0' && res.data) {
          this.total = res.data.total;
          this.tableList = res.data.list;
        }
      });
    },
    // 项目结算
    settleProject(projectId) {
      PurchaseBusinessService.projectSettlementById(projectId).then(res => {
        if (res && res.code === '0') {
          this.$alert('项目结算成功', ' ', {
            confirmButtonText: '确定',
            callback: () => {
              this.getPurchaseProjectList();
            }
          });
        } else {
          errorMessage(res && res.reason);
        }
      }).catch(error => {
        if (error && error.data && error.data.reason) {
          this.$errorMessage(error.data.reason);
        } else {
          this.$errorMessage('项目结算失败');
        }
      });
    },
    getProjectType (type) {
      if (type === 1) {
        return require('@/assets/images/common/engineering1.jpg');
      } else if (type === 2) {
        return require('@/assets/images/common/goods1.jpg');
      } else {
        return require('@/assets/images/common/service1.jpg');
      }
    },
    goToDetail (item) {
      window.open(window.location.origin + '/#/person-center/purchase-business/purchase-project/detail?id=' + item.id + '&flag=' + item.purchaseShowUploadNoticePic);
    },
    // 申请签署合同
    goSign (item) {
      // let params = new FormData();
      // params.append('purchaseId', item.id);
      PurchaseBusinessService.postSign1(item.id).then(res => {
        if(res.code === '0'){
          let msg = '已向'+ res.data.name +'的'+ res.data.mobile +'手机号发送邀请签约短信，请及时确认';
          successMessage(msg);
        }else{
          errorMessage(res.reason);
        }
      });
    },
    // 下载合同
    downloadConfirm (item){
      PurchaseBusinessService.downloadContract(item.id).then(res => {
        if(res.code === '0'){
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = 'data:file/doc;base64,' + res.data.contractUrl;
          link.download = ('农村集体采购项目合同.doc');
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link.href);
        }else{
          errorMessage(res.reason);
        }
      });
    },
    // 上传公告照片
    uploadAnnouncementImg (item) {
      this.$router.push('/person-center/purchase-business/purchase-project/upload-announcement-image?id=' + item.id);
    },
    // 确认成交书
    supplerConfirm (item) {
      this.$router.push('/person-center/purchase-business/purchase-project/confirmation-letter?id=' + item.id);
    },
    paymentSuccess () {
      this.getPurchaseProjectList();
    },
    // 预审时采购人审核报名人
    signUpReview (item) {
      this.$router.push('/person-center/purchase-business/purchase-project/audit-apply/list?id=' + item.id);
    },

    // 工程已经完成
    finishedProject(projectId) {
      this.$confirm('确定该工程已完成？确定后不可撤回', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        PurchaseBusinessService.finishedProject(projectId).then( res => {
          if (res && res.code === '0') {
            this.$alert('工程完成成功', ' ', {
              confirmButtonText: '确定',
              callback: () => {
                this.getPurchaseProjectList();
              }
            });
          } else {
            errorMessage(res && res.reason);
          }
        });
      });
    },

    // 退还保证金
    refundOfDeposit(item) {
      this.$confirm('确定要退还供应人保证金' + item.qualityMarginAmount + '元？退还后不可撤回。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        PurchaseBusinessService.refundOfDeposit(item.id).then( res => {
          if (res && res.code === '0') {
            this.$alert('保证金退还成功', ' ', {
              confirmButtonText: '确定',
              callback: () => {
                this.getPurchaseProjectList();
              }
            });
          } else {
            errorMessage(res && res.reason);
          }
        });
      });
    }
  }
};
